module.exports = __webpack_public_path__ + "static/img/dr-dalia.aa1da96a.jpg";